import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-cost-center-list',
  templateUrl: './../../../templates/forms/modals/cost-center-list-period-setup.component.html',
})
export class CostCenterListPeriodSetupComponent implements OnInit {
  @Input()
  ACC_NO: any;

  @Input()
  modalShow: boolean = true;

  @Input()
  costCenterForQJ;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "CostCenterListPeriodSetupGrid"

  dataObj: any;
  costCenterList: any[] = [];
  searchFields: any[] = ['COST_NAME', 'COST_NO'];
  public searchString;
  constructor(private dataService: CommonService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.costCenter, field: 'COST_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.costNo, field: 'COST_NO', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId); 
    if (!this.costCenterForQJ) {
      this.dataService.getChartCostlists(this.ACC_NO)
        .subscribe(arg => { this.costCenterList = arg.body; });
    } else {
      this.dataService.getCostCenters(this.costCenterForQJ, this.ACC_NO)
        .subscribe(arg => { this.costCenterList = arg.body; });
    }
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}
